<template>
    <!-- Start Features Area -->
    <section class="features-area-two ptb-80 bg-f7fafd">
        <div class="container">
            <div class="row h-100 justify-content-center align-items-center">
                <div class="col-lg-6 col-md-12 services-content">
                    <div class="section-title">
                        <h2>Guessing is an art</h2>
                        <div class="bar"></div>
                        <p>Take a sneak peek at what educates your business model guess. Have you ever thought about those factors? Together we look behind the curtain and analyze your guess.</p>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="activity"></feather> Entrepreneurial Experience
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="dollar-sign"></feather> Financial Necessities
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="users"></feather> Early Customer Insights
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="git-pull-request"></feather> Product Dependencies
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="shuffle"></feather> Experimentation Capabilities
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="trending-up"></feather> Business Model Trends
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="cloud"></feather> Personal Vision
                            </div>
                        </div>

                        <!--<div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="box">
                                <feather type="cloud"></feather> Hybrid cloud
                            </div>
                        </div>-->
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 services-right-image">
                    <!--<img src="../../../assets/img/services-right-image/book-self.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="book-self">
                    <img src="../../../assets/img/services-right-image/box.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="box">
                    <img src="../../../assets/img/services-right-image/chair.png" class="wow fadeInLeft" data-wow-delay="0.6s" alt="chair">
                    <img src="../../../assets/img/services-right-image/cloud.png" class="wow zoomIn" data-wow-delay="0.6s" alt="cloud">
                    <img src="../../../assets/img/services-right-image/cup.png" class="wow bounceIn" data-wow-delay="0.6s" alt="cup">
                    <img src="../../../assets/img/services-right-image/flower-top.png" class="wow fadeInDown" data-wow-delay="0.6s" alt="flower">
                    <img src="../../../assets/img/services-right-image/head-phone.png" class="wow zoomIn" data-wow-delay="0.6s" alt="head-phone">
                    <img src="../../../assets/img/services-right-image/monitor.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="monitor">
                    <img src="../../../assets/img/services-right-image/mug.png" class="wow rotateIn" data-wow-delay="0.6s" alt="mug">
                    <img src="../../../assets/img/services-right-image/table.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="table">
                    <img src="../../../assets/img/services-right-image/tissue.png" class="wow zoomIn" data-wow-delay="0.6s" alt="tissue">
                    <img src="../../../assets/img/services-right-image/water-bottle.png" class="wow zoomIn" data-wow-delay="0.6s" alt="water-bottle">
                    <img src="../../../assets/img/services-right-image/wifi.png" class="wow fadeInLeft" data-wow-delay="0.6s" alt="wifi">-->
                    <img src="../../../assets/img/services-right-image/cercle-shape.png" class="bg-image rotateme" alt="shape">

                   <!-- <img src="../../../assets/img/services-right-image/4841_v2.jpg" class="wow fadeInUp" data-wow-delay="0.6s" alt="main-pic">-->
                </div>
            </div>
        </div>
    </section>
    <!-- End Features Area -->
</template>

<script>
export default {
    name: 'FeaturesArea'
}
</script>